import React from 'react';

// Helpers
import { isConsumerDomain, validEmail } from 'Shared/helpers';

// Components
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';

// Styles
import './ZoomInviteScreen.scss';

type Props = {
  handleSkip: () => void;
  handleAdvanceOnboarding: Function;
};

const ZoomInviteScreen = ({ handleSkip, handleAdvanceOnboarding }: Props) => {
  const handleSubmitclick = values => {
    handleAdvanceOnboarding(values);
  };

  const isValidEmail = value => {
    if (value === '') return true;

    const isValidEmail = validEmail(value);
    const consumerDomain = isConsumerDomain(value);
    return isValidEmail && !consumerDomain;
  };

  const baseClassName = 'ZoomInviteScreen';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__title`}>
        <h4>Invite your teammate</h4>
        <p className={`${baseClassName}__title__subtitle`}>
          Don’t worry they will only be invited if you add their email
        </p>
      </div>
      <div className={`${baseClassName}__body`}>
        <WpForm onSubmit={handleSubmitclick}>
          <WpFormLayout direction="vertical">
            <WpTextField id="name" label="Name" required autoFocus />
            <WpTextField
              name="email"
              id="email"
              type="text"
              label="Email (optional)"
              placeholder=""
              validate={{
                isEmail: {
                  callback: isValidEmail,
                  error: 'Please enter a valid work email.',
                },
              }}
            />
          </WpFormLayout>
          <WpButtonGroup spacing="md" stacked block>
            <WpButton btnType="submit" size="lg" block>
              Get Started
            </WpButton>
            <WpButton variant="tertiary" size="lg" block onClick={handleSkip}>
              I&apos;ll invite later
            </WpButton>
          </WpButtonGroup>
        </WpForm>
      </div>
    </div>
  );
};

export default ZoomInviteScreen;
